














// import React, { useState,useEffect } from "react";
// import "../../css/Items.css";
// import { FaSearch, FaPlusCircle } from "react-icons/fa";
// import { MdGridView } from "react-icons/md";
// import { FaCamera } from "react-icons/fa";
// import "../../App.css";
// import axios from "axios"
// import { useNavigate,useLocation  } from "react-router-dom";
// import { FaFileExcel } from "react-icons/fa";
// import { FaEdit, FaTrash } from "react-icons/fa";
// import {
//   showSuccess,
//   showError,
// } from "../../General/Toast";



// // const Items = () => {
//   const Items = ({ clientData }) => {
//     const [selectedFormIndex, setSelectedFormIndex] = useState(null);
//   const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
// const [showAddUnitModal, setShowAddUnitModal] = useState(false);

// const [newCategoryName, setNewCategoryName] = useState("");
// const [newUnitName, setNewUnitName] = useState("");

// const [addingCategory, setAddingCategory] = useState(false);
// const [addingUnit, setAddingUnit] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
// const [itemToDelete, setItemToDelete] = useState(null);
//   const [discountInPercent, setDiscountInPercent] = useState(true);
//   const [editId, setEditId] = useState(null);
//   const [categories, setCategories] = useState([]);
// // const client_id = localStorage.getItem("client_id");
// const client_id = clientData?.id;
//   const navigate = useNavigate();
//   const location = useLocation();
//       const [showPartyForm, setShowPartyForm] = useState(false);
//       const [showFilter, setShowFilter] = useState(false);
//       const [purPriceWithTax, setPurPriceWithTax] = useState(false);
// const [filterType, setFilterType] = useState("Products");
// const [units, setUnits] = useState([]);
// const [salePriceWithTax, setSalePriceWithTax] = useState(false);
// const [inventory, setInventory] = useState([]);



// const formatDate = (value) => {
//   if (!value) return "";

//   return value.includes("T")
//     ? value.split("T")[0]
//     : value.split(" ")[0];
// };

// const handleEdit = (item) => {
//   setEditId(item.id);

//   setForms([
//     {
//       ...item,
//       mfgDate: formatDate(item.mfgDate),
//       expDate: formatDate(item.expDate),
//       date: formatDate(item.date),
//       image: null,
//       imagePreview: item.image
//         ? `https://api.dectwinbilling.com/dUploads/${item.image}`
//         : null,
//     },
//   ]);

//   setShowItemForm(true);
// };

// const handleDelete = (item) => {
//   setItemToDelete(item);
//   setShowDeleteModal(true);
// };
// const handleAddCategory = async (index) => {
//   const categoryName = newCategoryName.trim();

//   if (!categoryName) {
//     showError("Please enter category name");
//     return;
//   }

//   try {
//     setAddingCategory(true);

//     const response = await axios.post(
//       "https://api.dectwinbilling.com/add-category",
//       {
//         cat_name: categoryName,
//         cat_type: "Category",
//         client_id: client_id,
//       }
//     );

//     // SUCCESS POPUP
//     showSuccess("Category Added Successfully");

//     // Refresh category list from DB
//     await fetchCategories();

//     // Select newly added category
//     if (index !== null && index !== undefined) {
//       setForms((prev) =>
//         prev.map((item, i) =>
//           i === index
//             ? {
//                 ...item,
//                 category: categoryName,
//               }
//             : item
//         )
//       );
//     }

//     // Close popup
//     setNewCategoryName("");
//     setShowAddCategoryModal(false);
//     setSelectedFormIndex(null);

//   } catch (error) {
//     console.log("Add Category Error:", error);

//     showError(
//       error.response?.data?.message ||
//       "Failed to add category"
//     );
//   } finally {
//     setAddingCategory(false);
//   }
// };
// const handleAddUnit = async (index) => {
//   const unitName = newUnitName.trim();

//   if (!unitName) {
//     showError("Please enter unit name");
//     return;
//   }

//   try {
//     setAddingUnit(true);

//     const response = await axios.post(
//       "https://api.dectwinbilling.com/add-category",
//       {
//         cat_name: unitName,
//         cat_type: "unit",
//         client_id: client_id,
//       }
//     );

//     // SUCCESS POPUP
//     showSuccess("Unit Added Successfully");

//     // Refresh units from DB
//     await fetchUnits();

//     // Select newly added unit
//     if (index !== null && index !== undefined) {
//       setForms((prev) =>
//         prev.map((item, i) =>
//           i === index
//             ? {
//                 ...item,
//                 unit: unitName,
//               }
//             : item
//         )
//       );
//     }

//     // Close popup
//     setNewUnitName("");
//     setShowAddUnitModal(false);
//     setSelectedFormIndex(null);

//   } catch (error) {
//     console.log("Add Unit Error:", error);

//     showError(
//       error.response?.data?.message ||
//       "Failed to add unit"
//     );
//   } finally {
//     setAddingUnit(false);
//   }
// };
// // const handleAddCategory = async (index) => {
// //   const categoryName = newCategoryName.trim();

// //   if (!categoryName) {
// //     showError("Please enter category name");
// //     return;
// //   }

// //   try {
// //     setAddingCategory(true);

// //     const response = await axios.post(
// //       "https://api.dectwinbilling.com/add-category",
// //       {
// //         cat_name: categoryName,
// //         cat_type: "Category",
// //         client_id: client_id,
// //       }
// //     );

// //     showSuccess(
// //       response.data.message || "Category Added Successfully"
// //     );

// //     // Add new category immediately to dropdown
// //     const newCategory = {
// //       id:
// //         response.data.result?.[0] ||
// //         response.data.result?.insertId ||
// //         Date.now(),
// //       cat_name: categoryName,
// //     };

// //     setCategories((prev) => [...prev, newCategory]);

// //     // Automatically select newly added category
// //     const updatedForms = [...forms];

// //     updatedForms[index] = {
// //       ...updatedForms[index],
// //       category: categoryName,
// //     };

// //     setForms(updatedForms);

// //     setNewCategoryName("");
// //     setShowAddCategoryModal(false);

// //     // Refresh from database also
// //     fetchCategories();

// //   } catch (error) {
// //     console.log("Add Category Error:", error);

// //     showError(
// //       error.response?.data?.message ||
// //       "Failed to add category"
// //     );
// //   } finally {
// //     setAddingCategory(false);
// //   }
// // };
// // const handleAddUnit = async (index) => {
// //   const unitName = newUnitName.trim();

// //   if (!unitName) {
// //     showError("Please enter unit name");
// //     return;
// //   }

// //   try {
// //     setAddingUnit(true);

// //     const response = await axios.post(
// //       "https://api.dectwinbilling.com/add-category",
// //       {
// //         cat_name: unitName,
// //         cat_type: "unit",
// //         client_id: client_id,
// //       }
// //     );

// //     showSuccess(
// //       response.data.message || "Unit Added Successfully"
// //     );

// //     // Add new unit immediately to dropdown
// //     const newUnit = {
// //       id:
// //         response.data.result?.[0] ||
// //         response.data.result?.insertId ||
// //         Date.now(),
// //       cat_name: unitName,
// //     };

// //     setUnits((prev) => [...prev, newUnit]);

// //     // Automatically select newly added unit
// //     const updatedForms = [...forms];

// //     updatedForms[index] = {
// //       ...updatedForms[index],
// //       unit: unitName,
// //     };

// //     setForms(updatedForms);

// //     setNewUnitName("");
// //     setShowAddUnitModal(false);

// //     // Refresh from database also
// //     fetchUnits();

// //   } catch (error) {
// //     console.log("Add Unit Error:", error);

// //     showError(
// //       error.response?.data?.message ||
// //       "Failed to add unit"
// //     );
// //   } finally {
// //     setAddingUnit(false);
// //   }
// // };
// const confirmDeleteItem = async () => {
//   try {
//     const response = await axios.delete(
//       `https://api.dectwinbilling.com/delete-inventory/${client_id}/${itemToDelete.id}`
//     );

//     showSuccess(response.data.message);

//     fetchInventory();

//     setShowDeleteModal(false);
//     setItemToDelete(null);

//   } catch (error) {
//     console.error(error);

//     showError(
//       error.response?.data?.message ||
//       "Failed to delete item"
//     );
//   }
// };





// const handleSubmit = async () => {
//   try {

//     if (editId) {

   
//       const formData = new FormData();

//       Object.keys(forms[0]).forEach((key) => {
//         if (key !== "imagePreview") {
//           formData.append(key, forms[0][key]);
//         }
//       });

//       formData.append("client_id", client_id);

//       await axios.put(
//         `https://api.dectwinbilling.com/edit-inventory/${editId}`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       showSuccess("Product updated successfully");
//     }

//     else {

     
//       for (const form of forms) {


//   if (!form.name?.trim()) {
//     continue;
//   }

//   const formData = new FormData();

//   Object.keys(form).forEach((key) => {

//     if (key !== "imagePreview") {

//       formData.append(
//         key,
//         form[key]
//       );

//     }

//   });

//   formData.append(
//     "client_id",
//     client_id
//   );

//   await axios.post(
//     "https://api.dectwinbilling.com/inventory/upsert",
//     formData,
//     {
//       headers: {
//         "Content-Type":
//           "multipart/form-data",
//       },
//     }
//   );

// }

//       showSuccess("Products added successfully");
//     }

//     setShowItemForm(false);
//     setEditId(null);
//     setForms([{ ...emptyProduct }]);

//     fetchInventory();

//   } catch (error) {

//     console.log(error);

//     showError(
//       error.response?.data?.message ||
//       "Something went wrong"
//     );

//   }
// };
// // const fetchInventory = async () => {
// //   try {
// //     const response = await axios.get(
// //       `https://api.dectwinbilling.com/fetch-inventory/${client_id}`
// //     );

// //     console.log("Inventory Data:", response.data);

// //     setInventory(response.data);
// //   } catch (error) {
// //     console.log("Inventory Fetch Error:", error);
// //     setInventory([]);
// //   }
// // };
// const fetchInventory = async () => {
//   try {
//     const response = await axios.get(
//       `https://api.dectwinbilling.com/fetch-inventory/${client_id}`
//     );

//     console.log("Inventory Data:", response.data);

//     const productData = response.data.filter(
//       (item) => item.typeOfItem === "product"
//     );

//     setInventory(productData);
//   } catch (error) {
//     console.log("Inventory Fetch Error:", error);
//     setInventory([]);
//   }
// };
// const fetchUnits = async () => {
//   try {
//     const response = await axios.get(
//       `https://api.dectwinbilling.com/fetch-unit/${client_id}`
//     );

//     setUnits(response.data);
//   } catch (error) {
//     console.log("Unit Fetch Error:", error);
//   }
// };
// useEffect(() => {
//   fetchCategories();
//   fetchUnits();
//   fetchInventory();
// }, []);
// const fetchCategories = async () => {
//   try {
//     const response = await axios.get(
//       `https://api.dectwinbilling.com/fetch-category/${client_id}`
//     );

//     setCategories(response.data);
//   } catch (error) {
//     console.log("Category Fetch Error:", error);
//   }
// };
// useEffect(() => {
//   fetchCategories();
// }, []);
// const handleChange = (index, e) => {
//   const updatedForms = [...forms];

//   updatedForms[index] = {
//     ...updatedForms[index],
//     [e.target.name]: e.target.value,
//   };

//   setForms(updatedForms);
// };
// const emptyProduct = {
//   name: "",
//   barcode: "",
//   hsn_code: "",
//   unit: "",
//   category: "",
//   mfgDate: "",
//   expDate: "",
//   mrp: "",
//   wholesale: "",
//   pur_price: "",
//   pur_price_withTax: "Without Tax",
//   sale_price: "",
//   sale_price_withTax: "Without Tax",
//   taxRate: "",
//   discount: "",
//   dis_in_percent: "Percent",
//   stock: "",
//   stock_at_price: "",
//   min_to_maintain: "",
//   stock_place: "",
//   typeOfItem: "product",
//   date: new Date().toISOString().split("T")[0],
//   image: null,
//   imagePreview: null,
// };
// const [forms, setForms] = useState([{ ...emptyProduct }]);

// const [showItemForm, setShowItemForm] = useState(false);

// const handleAddMore = () => {
// setForms([
//   ...forms,
//   { ...emptyProduct },
// ]);
//   setEditId(null);
// setShowItemForm(true);
// };
// const handleAddLess = () => {
//   if (forms.length > 1) {
//     setForms(forms.slice(0, -1));
//   }
// };


// const filteredInventory = inventory.filter((item) =>
//   item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//   item.category?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//   item.barcode?.toLowerCase().includes(searchTerm.toLowerCase())
// );
// const handleImageChange = (index, e) => {
//   const file = e.target.files[0];

//   if (file) {
//     const updatedForms = [...forms];

//     updatedForms[index].image = file;
//     updatedForms[index].imagePreview =
//       URL.createObjectURL(file);

//     setForms(updatedForms);
//   }
// };

// return (
//     <div className="items-container">

//       <div className="items-header">

//         <h3>Items</h3>

//         <div className="items-actions">

//           <div className="search-box">
//           <input
//   type="text"
//   placeholder="Search Item"
//   value={searchTerm}
//   onChange={(e) =>
//     setSearchTerm(e.target.value)
//   }
// />
//             <FaSearch />
//           </div>

         
//           <button
//   className="add-item-btn"
//   onClick={() => {
//     setEditId(null);

//    setForms([{ ...emptyProduct }]);
// setShowItemForm(true);


//   }}
// >
//   <FaPlusCircle />
//   Add Product
// </button>


//            <div className="filter-container">
//   <button
//     className="grid-btn"
//     onClick={() => setShowFilter(!showFilter)}
//   >
//     <MdGridView />
//   </button>
  
//   {showDeleteModal && itemToDelete && (
//   <div
//     style={{
//       position: "fixed",
//       inset: 0,
//       background: "rgba(0,0,0,0.6)",
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       zIndex: 99999,
//     }}
//   >
//     <div
//       style={{
//         width: "400px",
//         background: "#fff",
//         borderRadius: "12px",
//         padding: "25px",
//         textAlign: "center",
//         boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
//       }}
//     >
//       <h4 style={{ color: "#dc3545" }}>
//         Delete Item
//       </h4>

//       <p style={{ marginTop: "15px" }}>
//         Are you sure you want to delete
//         <br />
//         <strong>{itemToDelete.name}</strong> ?
//       </p>

//       <div
//         style={{
//           display: "flex",
//           gap: "10px",
//           marginTop: "20px",
//         }}
//       >
//         <button
//           onClick={() => {
//             setShowDeleteModal(false);
//             setItemToDelete(null);
//           }}
//           style={{
//             flex: 1,
//             padding: "10px",
//             border: "none",
//             borderRadius: "8px",
//             background: "#ccc",
//             cursor: "pointer",
//           }}
//         >
//           Cancel
//         </button>

//         <button
//           onClick={confirmDeleteItem}
//           style={{
//             flex: 1,
//             padding: "10px",
//             border: "none",
//             borderRadius: "8px",
//             background: "#dc3545",
//             color: "#fff",
//             cursor: "pointer",
//           }}
//         >
//           Delete
//         </button>
//       </div>
//     </div>
//   </div>
// )}
// {/* ================= ADD UNIT MODAL ================= */}

// {showAddUnitModal && (
//   <div
//     style={{
//       position: "fixed",
//       inset: 0,
//       background: "rgba(0,0,0,0.55)",
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       zIndex: 1000000,
//     }}
//   >
//     <div
//       style={{
//         width: "400px",
//         maxWidth: "90%",
//         background: "#fff",
//         borderRadius: "12px",
//         padding: "25px",
//         boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
//       }}
//     >

//       <h3
//         style={{
//           marginBottom: "20px",
//           textAlign: "center",
//         }}
//       >
//         Add Unit
//       </h3>

//       <input
//         type="text"
//         value={newUnitName}
//         onChange={(e) =>
//           setNewUnitName(e.target.value)
//         }
//         placeholder="Enter Unit Name"
//         autoFocus
//         onKeyDown={(e) => {
//           if (e.key === "Enter") {
//             e.preventDefault();

//             if (selectedFormIndex !== null) {
//               handleAddUnit(selectedFormIndex);
//             }
//           }
//         }}
//         style={{
//           width: "100%",
//           padding: "12px",
//           border: "1px solid #d1d5db",
//           borderRadius: "8px",
//           outline: "none",
//           fontSize: "14px",
//           boxSizing: "border-box",
//         }}
//       />

//       <div
//         style={{
//           display: "flex",
//           gap: "10px",
//           marginTop: "20px",
//         }}
//       >

//         {/* CANCEL */}
//         <button
//           type="button"
//           onClick={() => {
//             setShowAddUnitModal(false);
//             setNewUnitName("");
//             setSelectedFormIndex(null);
//           }}
//           style={{
//             flex: 1,
//             padding: "11px",
//             border: "none",
//             borderRadius: "8px",
//             background: "#6b7280",
//             color: "#fff",
//             cursor: "pointer",
//           }}
//         >
//           Cancel
//         </button>

//         {/* SUBMIT */}
//         <button
//           type="button"
//           disabled={addingUnit}
//           onClick={() => {
//             if (selectedFormIndex !== null) {
//               handleAddUnit(selectedFormIndex);
//             }
//           }}
//           style={{
//             flex: 1,
//             padding: "11px",
//             border: "none",
//             borderRadius: "8px",
//             background: "#F96E5B",
//             color: "#fff",
//             cursor: addingUnit
//               ? "not-allowed"
//               : "pointer",
//           }}
//         >
//           {addingUnit ? "Adding..." : "Submit"}
//         </button>

//       </div>
//     </div>
//   </div>
// )}
//  {showFilter && (
//   <div className="filter-dropdown">

//     <div
//       className={location.pathname === "/items" ? "active-menu" : ""}
//       onClick={() => {
//         setFilterType("product");
//         setShowFilter(false);
//         navigate("/items");
//       }}
//     >
//       Product
//     </div>

//     <div
//       className={location.pathname === "/services" ? "active-menu" : ""}
//       onClick={() => {
//         setFilterType("Services");
//         setShowFilter(false);
//         navigate("/services");
//       }}
//     >
//       Services
//     </div>

//     <div
//       className={location.pathname === "/category" ? "active-menu" : ""}
//       onClick={() => {
//         setFilterType("Categories");
//         setShowFilter(false);
//         navigate("/category");
//       }}
//     >
//       Categories
//     </div>

//     <div
//       className={location.pathname === "/units" ? "active-menu" : ""}
//       onClick={() => {
//         setFilterType("Units");
//         setShowFilter(false);
//         navigate("/units");
//       }}
//     >
//       Units
//     </div>

//   </div>
// )}
// </div>

//         </div>

//       </div>

// <div className="items-table-wrapper">

//   <div className="table-header">
//     <span>Item Name</span>
//     <span>Category</span>
//     <span>Purchase Price</span>
//     <span>Sale Price</span>
//     <span>Stock</span>
//     <span>GST</span>
//     <span>Activity</span>
//   </div>

//  {filteredInventory.length > 0 ? (
//   filteredInventory.map((item) => (
//       <div key={item.id} className="table-row">
//            <span>{item.name}</span>
//       <span>{item.category}</span>
//       <span>₹{item.pur_price}</span>
//       <span>₹{item.sale_price}</span>
//       <span>{item.stock}</span>
//       <span>{item.taxRate}</span>
// <span className="action-btns">
//   <button
//     className="btn btn-sm btn-outline-primary"
//     onClick={() => handleEdit(item)}
//   >
//     <FaEdit />
//   </button>
// <button
//   className="btn btn-sm btn-outline-danger"
//   onClick={() => handleDelete(item)}
// >
//   <FaTrash />
// </button>
// </span>
//       </div>
//     ))
//   ) : (
//     <div className="empty-state">
//       <h3>No Items to Show</h3>
//     </div>
//   )}

// </div>

//       <div className="empty-state">

//  {/* ================= ADD CATEGORY MODAL ================= */}

// {showAddCategoryModal && (
//   <div
//     style={{
//       position: "fixed",
//       inset: 0,
//       background: "rgba(0,0,0,0.55)",
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       zIndex: 999999,
//     }}
//   >
//     <div
//       style={{
//         width: "400px",
//         maxWidth: "90%",
//         background: "#fff",
//         borderRadius: "12px",
//         padding: "25px",
//         boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
//       }}
//     >
//       <h3
//         style={{
//           marginBottom: "20px",
//           textAlign: "center",
//         }}
//       >
//         Add Category
//       </h3>

//       <input
//         type="text"
//         value={newCategoryName}
//         onChange={(e) =>
//           setNewCategoryName(e.target.value)
//         }
//         placeholder="Enter Category Name"
//         autoFocus
//         style={{
//           width: "100%",
//           padding: "12px",
//           border: "1px solid #d1d5db",
//           borderRadius: "8px",
//           outline: "none",
//           fontSize: "14px",
//           boxSizing: "border-box",
//         }}
//         onKeyDown={(e) => {
//           if (e.key === "Enter") {
//             e.preventDefault();

//             // index available nahi hota modal ke bahar
//             // isliye selected index state use karna better hai
//           }
//         }}
//       />

//       <div
//         style={{
//           display: "flex",
//           gap: "10px",
//           marginTop: "20px",
//         }}
//       >
//         <button
//           type="button"
//           onClick={() => {
//             setShowAddCategoryModal(false);
//             setNewCategoryName("");
//           }}
//           style={{
//             flex: 1,
//             padding: "11px",
//             border: "none",
//             borderRadius: "8px",
//             background: "#6b7280",
//             color: "#fff",
//             cursor: "pointer",
//           }}
//         >
//           Cancel
//         </button>

//         <button
//           type="button"
//           disabled={addingCategory}
//           onClick={() =>
//             handleAddCategory(selectedFormIndex)
//           }
//           style={{
//             flex: 1,
//             padding: "11px",
//             border: "none",
//             borderRadius: "8px",
//             background: "#F96E5B",
//             color: "#fff",
//             cursor: "pointer",
//           }}
//         >
//           {addingCategory ? "Adding..." : "Submit"}
//         </button>
//       </div>
//     </div>
//   </div>
// )}    

// {showItemForm && (
//   <div className="party-modal-overlay">
//     <div className="item-modal">

//       <div className="item-modal-header">
      
//           <h2>
//     {editId ? "Edit Product" : "Add Product"}
//   </h2>

//         <button
//           className="back-btn"
//        onClick={() => {
//   setShowItemForm(false);
//   setEditId(null);
// setForms([
//   ...forms,
//   { ...emptyProduct },
// ]);
// }}
//         >
//           ← Back
//         </button>
//       </div>

//       <div className="product-layout">


// <div className="form-sections">

// {forms.map((form, index) => (
//   <div
//     key={index}
//     className="product-card"
//   >
//     <div className="row">

      
//       <div className="col-md-9">
//         <h2 className="mb-3">
//           Product {index + 1}
//         </h2>

//         <div className="form-card">
//           <h3>Item Details</h3>

//          <div className="item-grid">
// <input
//   name="name"
//   value={form.name}
//   onChange={(e) => handleChange(index, e)}
//   placeholder="Item Name*"
// />

//   <input
//     name="barcode"
//     value={form.barcode}
//     onChange={(e) => handleChange(index, e)}
//     placeholder="Item Code"
//   />

//   <input
//     name="hsn_code"
//     value={form.hsn_code}
// onChange={(e) => handleChange(index, e)}
//     placeholder="HSN Code"
//   />

// {/* <select
//   name="category"
//   value={form.category}
// onChange={(e) => handleChange(index, e)}
// >
//   <option value="">Select Category</option>

//   {categories.map((cat) => (
//     <option
//       key={cat.id}
//       value={cat.cat_name}
//     >
//       {cat.cat_name}
//     </option>
//   ))}
// </select> */}
// <select
//   name="category"
//   value={form.category}
//   onChange={(e) => {
//     if (e.target.value === "__ADD_CATEGORY__") {
//       setSelectedFormIndex(index);
//       setNewCategoryName("");
//       setShowAddCategoryModal(true);
//       return;
//     }

//     handleChange(index, e);
//   }}
// >
//   <option value="">Select Category</option>

//   {categories.map((cat) => (
//     <option
//       key={cat.id}
//       value={cat.cat_name}
//     >
//       {cat.cat_name}
//     </option>
//   ))}

//   <option value="__ADD_CATEGORY__">
//     + Add Category
//   </option>
// </select>
// <select
//   name="unit"
//   value={form.unit}
//   onChange={(e) => {
//     if (e.target.value === "__ADD_UNIT__") {
//       setSelectedFormIndex(index);
//       setNewUnitName("");
//       setShowAddUnitModal(true);
//       return;
//     }

//     handleChange(index, e);
//   }}
// >
//   <option value="">Select Unit</option>

//   {units.map((unit) => (
//     <option
//       key={unit.id}
//       value={unit.cat_name}
//     >
//       {unit.cat_name}
//     </option>
//   ))}

//   <option value="__ADD_UNIT__">
//     + Add Unit
//   </option>
// </select>
// {/* <select
//   name="unit"
//   value={form.unit}
//   onChange={(e) => handleChange(index, e)}
// >
//   <option value="">Select Unit</option>

//   {units.map((unit) => (
//     <option
//       key={unit.id}
//       value={unit.cat_name}
//     >
//       {unit.cat_name}
//     </option>
//   ))}
// </select> */}
//   <input
//     type="date"
//     name="mfgDate"
//     value={form.mfgDate}
//     onChange={(e) => handleChange(index, e)}
//   />
// </div>
//         </div>

//         <div className="form-card">
//           <h3>Price Details</h3>

//           <div className="item-grid">
//          <input
//   name="mrp"
//   value={form.mrp}
//   onChange={(e) => handleChange(index, e)}
//   placeholder="MRP Price*"
// />

// <div className="position-relative w-100">

//   <input
//     type="text"
//     name="pur_price"
//     value={form.pur_price}
//     onChange={(e) => handleChange(index, e)}
//     placeholder="Purchase Price*"
//     className="form-control"
//     style={{ paddingRight: "120px" }}
//   />

//   <button
//     type="button"
//     className="btn btn-sm position-absolute top-50 end-0 translate-middle-y me-2"


//     onClick={() => {
//   const value = !purPriceWithTax;

//   setPurPriceWithTax(value);

// const updatedForms = [...forms];

// updatedForms[index].pur_price_withTax =
//   value ? "With Tax" : "Without Tax";

// setForms(updatedForms);
// }}
//     style={{
//   backgroundColor: "#F96E5B",
//   color: "#fff",
//   border: "none",
//   borderRadius: "20px",
//   minWidth: "95px",
// }}
//   >
//     {purPriceWithTax
//       ? "With Tax"
//       : "Without Tax"}
//   </button>

// </div>
// <div className="position-relative w-100">

//   <input
//     type="text"
//     name="sale_price"
// value={form.sale_price}
// onChange={(e) => handleChange(index, e)}
//     placeholder="Sale Price*"
//     className="form-control"
//     style={{ paddingRight: "120px" }}
//   />

//  <button
//   type="button"
//   className="btn btn-sm position-absolute top-50 end-0 translate-middle-y me-2"
// onClick={() => {
//   const value = !salePriceWithTax;

//   setSalePriceWithTax(value);
// const updatedForms = [...forms];

// updatedForms[index].sale_price_withTax =
//   value ? "With Tax" : "Without Tax";

// setForms(updatedForms);
// }}
//   style={{
//     backgroundColor: "#F96E5B",
//     color: "#fff",
//     border: "none",
//     borderRadius: "20px",
//     minWidth: "95px",
//   }}
// >
//   {salePriceWithTax
//     ? "With Tax"
//     : "Without Tax"}
// </button>

// </div>

// <div className="position-relative w-100">

//   <input
//     type="text"
//     name="discount"
//   value={form.discount}
// onChange={(e) => handleChange(index, e)}
//     placeholder="Discount"
//     className="form-control"
//     style={{ paddingRight: "120px" }}
//   />

//   <button
//     type="button"
//     className="btn btn-sm position-absolute top-50 end-0 translate-middle-y me-2"
//     style={{
//       backgroundColor: "#F96E5B",
//       color: "#fff",
//       border: "none",
//       borderRadius: "20px",
//       minWidth: "95px",
//     }}
// onClick={() => {
//   const value = !discountInPercent;

//   setDiscountInPercent(value);

//   const updatedForms = [...forms];

//   updatedForms[index].dis_in_percent =
//     value ? "Percent" : "Amount";

//   setForms(updatedForms);
// }}
//   >
//     {discountInPercent ? " % percentage" : "₹ Amount"}
//   </button>

// </div>

// <input
//   type="date"
//   name="expDate"
// value={form.expDate || ""}
// onChange={(e) => handleChange(index, e)}
// />

// <select
//   name="taxRate"
//   value={form.taxRate}
//   onChange={(e) => handleChange(index, e)}
// >
//   <option value="">Tax Rate</option>
//   <option value="None">None</option>
//   <option value="GST 0%">GST 0%</option>
//   <option value="IGST 0%">IGST 0%</option>
//   <option value="GST 0.25%">GST 0.25%</option>
//   <option value="IGST 0.25%">IGST 0.25%</option>
//   <option value="GST 3%">GST 3%</option>
//   <option value="IGST 3%">IGST 3%</option>
//   <option value="GST 5%">GST 5%</option>
//    <option value="IGST 5%">IGST 5%</option>
//      <option value="GST 12%">GST 12%</option>
//         <option value="IGST 12%">IGST 12%</option>
//              <option value="GST 18%">GST 18%</option>
//         <option value="IGST 18%">IGST 18%</option>
//              <option value="GST 28%">GST 28%</option>
//         <option value="IGST 28%">IGST 28%</option>
  
// </select>
//           </div>
//         </div>

//         <div className="form-card">
//           <h3>Stock Details</h3>

//           <div className="item-grid">
//             <input
//   name="stock"
//   value={form.stock}
// onChange={(e) => handleChange(index, e)}
//   placeholder="Opening Quantity*"
// />

// <input
//   name="stock_at_price"
//   value={form.stock_at_price}
// onChange={(e) => handleChange(index, e)}
//   placeholder="At Price*"
// />

// <input
//   name="min_to_maintain"
//   value={form.min_to_maintain}
// onChange={(e) => handleChange(index, e)}
//   placeholder="Min Stock*"
// />

// <input
//   name="stock_place"
// value={form.stock_place}
// onChange={(e) => handleChange(index, e)}
//   placeholder="Location*"
// />
// <input
//   type="date"
//   name="date"
//   value={form.date || ""}
//   onChange={(e) => handleChange(index, e)}
// />
//           </div>
//         </div>

//       </div>

    
//    <div className="col-md-3">
//         <div className="image-upload-section">
//           <h3>Product Image</h3>

//           <div className="image-upload-box">
//             {form.imagePreview ? (
//               <img
//                 src={form.imagePreview}
//                 alt="preview"
//                 className="preview-image"
//               />
//             ) : (
//               <div className="upload-placeholder">
//                 <FaCamera size={50} />
//                 <p>Upload Image</p>
//               </div>
//             )}

//             <input
//               type="file"
//               accept="image/*"
//               className="image-input"
//               onChange={(e) => handleImageChange(index, e)}
//             />
//           </div>
//         </div>
//       </div>

//     </div>
//   </div>
// ))}
// </div>


  

// </div>

    
//       <div className="item-footer">

//   {!editId && (
//     <>
//       <button
//         className="more-btn"
//         onClick={handleAddMore}
//       >
//         + Add More
//       </button>

//       <button
//         className="less-btn"
//         onClick={handleAddLess}
//       >
//         - Add Less
//       </button>
//     </>
//   )}

//   <button
//     className="submit-btn"
//     onClick={handleSubmit}
//   >
//     {editId ? "Update" : "Submit"}
//   </button>

// </div>

//     </div>
//   </div>
// )}


//       </div>

//     </div>
    
    
    
//   );
// };



// export default Items;



import React, { useState, useEffect } from "react";
import "../../css/Items.css";
import { FaSearch, FaPlusCircle } from "react-icons/fa";
import { MdGridView } from "react-icons/md";
import { FaCamera } from "react-icons/fa";
import "../../App.css";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { FaEdit, FaTrash } from "react-icons/fa";
import {
  showSuccess,
  showError,
} from "../../General/Toast";

const Items = ({ clientData }) => {
  const [selectedFormIndex, setSelectedFormIndex] = useState(null);
  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const [showAddUnitModal, setShowAddUnitModal] = useState(false);

  const [newCategoryName, setNewCategoryName] = useState("");
  const [newUnitName, setNewUnitName] = useState("");

  const [addingCategory, setAddingCategory] = useState(false);
  const [addingUnit, setAddingUnit] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [discountInPercent, setDiscountInPercent] = useState(true);
  const [editId, setEditId] = useState(null);
  const [categories, setCategories] = useState([]);

  const client_id = clientData?.id;
  const navigate = useNavigate();
  const location = useLocation();

  const [showPartyForm, setShowPartyForm] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [purPriceWithTax, setPurPriceWithTax] = useState(false);
  const [filterType, setFilterType] = useState("Products");
  const [units, setUnits] = useState([]);
  const [salePriceWithTax, setSalePriceWithTax] = useState(false);
  const [inventory, setInventory] = useState([]);

  const formatDate = (value) => {
    if (!value) return "";

    return value.includes("T")
      ? value.split("T")[0]
      : value.split(" ")[0];
  };

  const handleEdit = (item) => {
    setEditId(item.id);

    setForms([
      {
        ...item,
        mfgDate: formatDate(item.mfgDate),
        expDate: formatDate(item.expDate),
        date: formatDate(item.date),
        image: null,
        imagePreview: item.image
          ? `https://api.dectwinbilling.com/dUploads/${item.image}`
          : null,
      },
    ]);

    setShowItemForm(true);
  };

  const handleDelete = (item) => {
    setItemToDelete(item);
    setShowDeleteModal(true);
  };

  const handleAddCategory = async (index) => {
    const categoryName = newCategoryName.trim();

    if (!categoryName) {
      showError("Please enter category name");
      return;
    }

    try {
      setAddingCategory(true);

      const response = await axios.post(
        "https://api.dectwinbilling.com/add-category",
        {
          cat_name: categoryName,
          cat_type: "Category",
          client_id: client_id,
        }
      );

      showSuccess("Category Added Successfully");

      await fetchCategories();

      if (index !== null && index !== undefined) {
        setForms((prev) =>
          prev.map((item, i) =>
            i === index
              ? {
                  ...item,
                  category: categoryName,
                }
              : item
          )
        );
      }

      setNewCategoryName("");
      setShowAddCategoryModal(false);
      setSelectedFormIndex(null);
    } catch (error) {
      console.log("Add Category Error:", error);

      showError(
        error.response?.data?.message ||
          "Failed to add category"
      );
    } finally {
      setAddingCategory(false);
    }
  };

  const handleAddUnit = async (index) => {
    const unitName = newUnitName.trim();

    if (!unitName) {
      showError("Please enter unit name");
      return;
    }

    try {
      setAddingUnit(true);

      const response = await axios.post(
        "https://api.dectwinbilling.com/add-category",
        {
          cat_name: unitName,
          cat_type: "unit",
          client_id: client_id,
        }
      );

      showSuccess("Unit Added Successfully");

      await fetchUnits();

      if (index !== null && index !== undefined) {
        setForms((prev) =>
          prev.map((item, i) =>
            i === index
              ? {
                  ...item,
                  unit: unitName,
                }
              : item
          )
        );
      }

      setNewUnitName("");
      setShowAddUnitModal(false);
      setSelectedFormIndex(null);
    } catch (error) {
      console.log("Add Unit Error:", error);

      showError(
        error.response?.data?.message ||
          "Failed to add unit"
      );
    } finally {
      setAddingUnit(false);
    }
  };

  const confirmDeleteItem = async () => {
    try {
      const response = await axios.delete(
        `https://api.dectwinbilling.com/delete-inventory/${client_id}/${itemToDelete.id}`
      );

      showSuccess(response.data.message);

      fetchInventory();

      setShowDeleteModal(false);
      setItemToDelete(null);
    } catch (error) {
      console.error(error);

      showError(
        error.response?.data?.message ||
          "Failed to delete item"
      );
    }
  };

  const handleSubmit = async () => {
    try {
      if (editId) {
        const formData = new FormData();

        Object.keys(forms[0]).forEach((key) => {
          if (key !== "imagePreview") {
            formData.append(key, forms[0][key]);
          }
        });

        formData.append("client_id", client_id);

        await axios.put(
          `https://api.dectwinbilling.com/edit-inventory/${editId}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        showSuccess("Product updated successfully");
      } else {
        for (const form of forms) {
          if (!form.name?.trim()) {
            continue;
          }

          const formData = new FormData();

          Object.keys(form).forEach((key) => {
            if (key !== "imagePreview") {
              formData.append(key, form[key]);
            }
          });

          formData.append("client_id", client_id);

          await axios.post(
            "https://api.dectwinbilling.com/inventory/upsert",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
        }

        showSuccess("Products added successfully");
      }

      setShowItemForm(false);
      setEditId(null);
      setForms([{ ...emptyProduct }]);

      fetchInventory();
    } catch (error) {
      console.log(error);

      showError(
        error.response?.data?.message ||
          "Something went wrong"
      );
    }
  };

  const fetchInventory = async () => {
    try {
      const response = await axios.get(
        `https://api.dectwinbilling.com/fetch-inventory/${client_id}`
      );

      console.log("Inventory Data:", response.data);

      const productData = response.data.filter(
        (item) => item.typeOfItem === "product"
      );

      setInventory(productData);
    } catch (error) {
      console.log("Inventory Fetch Error:", error);
      setInventory([]);
    }
  };

  const fetchUnits = async () => {
    try {
      const response = await axios.get(
        `https://api.dectwinbilling.com/fetch-unit/${client_id}`
      );

      setUnits(response.data);
    } catch (error) {
      console.log("Unit Fetch Error:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchUnits();
    fetchInventory();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(
        `https://api.dectwinbilling.com/fetch-category/${client_id}`
      );

      setCategories(response.data);
    } catch (error) {
      console.log("Category Fetch Error:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleChange = (index, e) => {
    const updatedForms = [...forms];

    updatedForms[index] = {
      ...updatedForms[index],
      [e.target.name]: e.target.value,
    };

    setForms(updatedForms);
  };

  const emptyProduct = {
    name: "",
    barcode: "",
    hsn_code: "",
    unit: "",
    category: "",
    mfgDate: "",
    expDate: "",
    mrp: "",
    wholesale: "",
    pur_price: "",
    pur_price_withTax: "Without Tax",
    sale_price: "",
    sale_price_withTax: "Without Tax",
    taxRate: "",
    discount: "",
    dis_in_percent: "Percent",
    stock: "",
    stock_at_price: "",
    min_to_maintain: "",
    stock_place: "",
    typeOfItem: "product",
    date: new Date().toISOString().split("T")[0],
    image: null,
    imagePreview: null,
  };

  const [forms, setForms] = useState([{ ...emptyProduct }]);
  const [showItemForm, setShowItemForm] = useState(false);

  const handleAddMore = () => {
    setForms([
      ...forms,
      { ...emptyProduct },
    ]);
    setEditId(null);
    setShowItemForm(true);
  };

  const handleAddLess = () => {
    if (forms.length > 1) {
      setForms(forms.slice(0, -1));
    }
  };

  const filteredInventory = inventory.filter((item) =>
    item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.category?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.barcode?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleImageChange = (index, e) => {
    const file = e.target.files[0];

    if (file) {
      const updatedForms = [...forms];

      updatedForms[index].image = file;
      updatedForms[index].imagePreview =
        URL.createObjectURL(file);

      setForms(updatedForms);
    }
  };

  return (
    <div className="items-container">      <style>{`
        /* =========================
           ITEMS — RESPONSIVE UI
           UI ONLY / LOGIC UNCHANGED
           ========================= */

        .items-container {
          width: 100%;
          max-width: 100%;
          min-width: 0;
          padding: 18px 20px 96px;
          box-sizing: border-box;
          background: #f6f8fb;
          color: #1f2937;
        }

        .items-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          margin-bottom: 18px;
          flex-wrap: wrap;
        }

        .items-header h3 {
          margin: 0;
          font-size: 24px;
          line-height: 1.2;
          font-weight: 700;
          color: #172033;
          letter-spacing: -.3px;
        }

        .items-actions {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-left: auto;
          flex-wrap: wrap;
        }

        .search-box {
          position: relative;
          width: min(300px, 100%);
          min-width: 220px;
        }

        .search-box input {
          width: 100%;
          height: 42px;
          padding: 0 40px 0 14px;
          border: 1px solid #e2e7ef;
          border-radius: 10px;
          background: #fff;
          color: #202938;
          outline: none;
          box-sizing: border-box;
          box-shadow: 0 2px 8px rgba(31,41,55,.04);
          transition: border-color .2s, box-shadow .2s;
        }

        .search-box input:focus {
          border-color: #f96e5b;
          box-shadow: 0 0 0 3px rgba(249,110,91,.12);
        }

        .search-box svg {
          position: absolute;
          right: 14px;
          top: 50%;
          transform: translateY(-50%);
          color: #8993a4;
          pointer-events: none;
        }

        .add-item-btn {
          min-height: 42px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 0 16px;
          border: 0;
          border-radius: 10px;
          background: #f96e5b;
          color: #fff;
          font-weight: 600;
          box-shadow: 0 5px 14px rgba(249,110,91,.20);
          transition: transform .18s, box-shadow .18s, background .18s;
        }

        .add-item-btn:hover {
          background: #ed5f4c;
          transform: translateY(-1px);
          box-shadow: 0 7px 18px rgba(249,110,91,.26);
        }

        .filter-container {
          position: relative;
          z-index: 30;
        }

        .grid-btn {
          width: 42px;
          height: 42px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #e2e7ef;
          border-radius: 10px;
          background: #fff;
          color: #536075;
          font-size: 21px;
          box-shadow: 0 2px 8px rgba(31,41,55,.04);
          transition: .18s;
        }

        .grid-btn:hover {
          color: #f96e5b;
          border-color: #f5b1a7;
        }

        .filter-dropdown {
          position: absolute;
          top: calc(100% + 8px);
          right: 0;
          width: 180px;
          overflow: hidden;
          padding: 6px;
          border: 1px solid #e7ebf2;
          border-radius: 12px;
          background: #fff;
          box-shadow: 0 12px 30px rgba(20,30,50,.14);
        }

        .filter-dropdown > div {
          padding: 10px 12px;
          border-radius: 8px;
          color: #4b5563;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: .15s;
        }

        .filter-dropdown > div:hover,
        .filter-dropdown .active-menu {
          background: #fff1ee;
          color: #e85f4c;
          font-weight: 600;
        }

        .items-table-wrapper {
          width: 100%;
          overflow-x: auto;
          overflow-y: visible;
          border: 1px solid #e8ecf2;
          border-radius: 14px;
          background: #fff;
          box-shadow: 0 4px 18px rgba(31,41,55,.055);
          -webkit-overflow-scrolling: touch;
        }

        .table-header,
        .table-row {
          min-width: 850px;
          display: grid;
          grid-template-columns:
            minmax(170px, 1.55fr)
            minmax(120px, 1fr)
            minmax(120px, 1fr)
            minmax(110px, 1fr)
            minmax(80px, .7fr)
            minmax(75px, .6fr)
            92px;
          align-items: center;
          column-gap: 14px;
          box-sizing: border-box;
        }

        .table-header {
          min-height: 48px;
          padding: 0 18px;
          border-bottom: 1px solid #edf0f4;
          background: #fafbfc;
          color: #7b8494;
          font-size: 12px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: .45px;
        }

        .table-row {
          min-height: 62px;
          padding: 8px 18px;
          border-bottom: 1px solid #f0f2f5;
          color: #303949;
          font-size: 14px;
          transition: background .15s;
        }

        .table-row:last-child {
          border-bottom: 0;
        }

        .table-row:hover {
          background: #fcfdfd;
        }

        .table-row > span {
          min-width: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .action-btns {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 7px;
          overflow: visible !important;
        }

        .action-btns button {
          width: 34px;
          height: 34px;
          padding: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px !important;
          margin: 0;
        }

        .empty-state {
          padding: 54px 20px;
          text-align: center;
          color: #8993a4;
        }

        .empty-state h3 {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
        }

        /* Main product modal */
        .party-modal-overlay {
          position: fixed !important;
          inset: 0 !important;
          z-index: 99998 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 16px !important;
          background: rgba(15,23,42,.58) !important;
          backdrop-filter: blur(3px);
          box-sizing: border-box;
        }

        .item-modal {
          width: min(1180px, 100%) !important;
          max-width: 1180px !important;
          max-height: calc(100vh - 32px);
          overflow: hidden auto;
          border: 1px solid rgba(255,255,255,.65);
          border-radius: 18px !important;
          background: #f7f9fc !important;
          box-shadow: 0 24px 70px rgba(15,23,42,.28) !important;
          box-sizing: border-box;
          scrollbar-width: thin;
        }

        .item-modal-header {
          position: sticky;
          top: 0;
          z-index: 20;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          padding: 16px 20px;
          border-bottom: 1px solid #e9edf3;
          background: rgba(255,255,255,.96);
          backdrop-filter: blur(10px);
        }

        .item-modal-header h2 {
          margin: 0;
          font-size: 20px;
          font-weight: 700;
          color: #172033;
        }

        .back-btn {
          border: 1px solid #e1e6ee !important;
          border-radius: 9px !important;
          background: #fff !important;
          color: #4b5563 !important;
          padding: 8px 13px !important;
          font-weight: 600;
          cursor: pointer;
          transition: .18s;
        }

        .back-btn:hover {
          border-color: #f3b0a6 !important;
          color: #e85f4c !important;
          background: #fff8f6 !important;
        }

        .product-layout {
          padding: 18px 20px 6px;
          box-sizing: border-box;
        }

        .form-sections {
          width: 100%;
        }

        .product-card {
          margin-bottom: 18px;
          padding: 0;
          border: 0;
          background: transparent;
        }

        .product-card > .row {
          display: grid;
          grid-template-columns:
            minmax(0, 3fr)
            minmax(250px, 1fr);
          gap: 18px;
          margin: 0 !important;
        }

        .product-card > .row > [class*="col-"] {
          width: auto !important;
          max-width: none !important;
          padding: 0 !important;
        }

        .product-card > .row > .col-md-9 {
          min-width: 0;
        }

        .product-card > .row > .col-md-3 {
          min-width: 0;
        }

        .product-card h2.mb-3 {
          margin: 0 0 10px !important;
          font-size: 17px;
          color: #202b3d;
        }

        .form-card,
        .image-upload-section {
          padding: 17px;
          border: 1px solid #e7ebf1;
          border-radius: 14px;
          background: #fff;
          box-shadow: 0 3px 12px rgba(31,41,55,.04);
        }

        .form-card {
          margin-bottom: 14px;
        }

        .form-card h3,
        .image-upload-section h3 {
          margin: 0 0 14px;
          font-size: 14px;
          font-weight: 700;
          color: #273247;
        }

        .form-card h3::after,
        .image-upload-section h3::after {
          content: "";
          display: block;
          width: 28px;
          height: 2px;
          margin-top: 7px;
          border-radius: 10px;
          background: #f96e5b;
        }

        .item-grid {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 11px;
          width: 100%;
        }

        .item-grid > input,
        .item-grid > select,
        .item-grid .position-relative input {
          width: 100%;
          min-width: 0;
          height: 42px;
          box-sizing: border-box;
          border: 1px solid #dfe5ed;
          border-radius: 9px;
          background: #fff;
          color: #293345;
          padding: 0 12px;
          outline: none;
          font-size: 13px;
          transition: border-color .18s, box-shadow .18s;
        }

        .item-grid > input:focus,
        .item-grid > select:focus,
        .item-grid .position-relative input:focus {
          border-color: #f4a092;
          box-shadow: 0 0 0 3px rgba(249,110,91,.10);
        }

        .item-grid > input::placeholder {
          color: #9aa3b1;
        }

        .item-grid .position-relative {
          min-width: 0;
        }

        .item-grid .position-relative input {
          padding-right: 112px !important;
        }

        .item-grid .position-relative button {
          min-width: 91px !important;
          height: 30px;
          border: 0 !important;
          border-radius: 16px !important;
          background: #f96e5b !important;
          color: #fff !important;
          font-size: 11px;
          font-weight: 600;
          padding: 0 9px;
          box-shadow: none;
          white-space: nowrap;
        }

        .item-grid select {
          cursor: pointer;
        }
      `}</style>

      <div className="items-header">
        <h3>Items</h3>

        <div className="items-actions">
          <div className="search-box">
            <input
              type="text"
              placeholder="Search Item"
              value={searchTerm}
              onChange={(e) =>
                setSearchTerm(e.target.value)
              }
            />
            <FaSearch />
          </div>

          <button
            className="add-item-btn"
            onClick={() => {
              setEditId(null);
              setForms([{ ...emptyProduct }]);
              setShowItemForm(true);
            }}
          >
            <FaPlusCircle />
            Add Product
          </button>

          <div className="filter-container">
            <button
              className="grid-btn"
              onClick={() => setShowFilter(!showFilter)}
            >
              <MdGridView />
            </button>            {showFilter && (
              <div className="filter-dropdown">

                <div
                  className={
                    location.pathname === "/items"
                      ? "active-menu"
                      : ""
                  }
                  onClick={() => {
                    setFilterType("product");
                    setShowFilter(false);
                    navigate("/items");
                  }}
                >
                  Product
                </div>

                <div
                  className={
                    location.pathname === "/services"
                      ? "active-menu"
                      : ""
                  }
                  onClick={() => {
                    setFilterType("Services");
                    setShowFilter(false);
                    navigate("/services");
                  }}
                >
                  Services
                </div>

                <div
                  className={
                    location.pathname === "/category"
                      ? "active-menu"
                      : ""
                  }
                  onClick={() => {
                    setFilterType("Categories");
                    setShowFilter(false);
                    navigate("/category");
                  }}
                >
                  Categories
                </div>

                <div
                  className={
                    location.pathname === "/units"
                      ? "active-menu"
                      : ""
                  }
                  onClick={() => {
                    setFilterType("Units");
                    setShowFilter(false);
                    navigate("/units");
                  }}
                >
                  Units
                </div>

              </div>
            )}
          </div>
        </div>
      </div>

      {/* ================= DELETE MODAL ================= */}

      {showDeleteModal && itemToDelete && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15,23,42,0.60)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "15px",
            zIndex: 99999,
            backdropFilter: "blur(3px)",
          }}
        >
          <div
            style={{
              width: "400px",
              maxWidth: "100%",
              background: "#fff",
              borderRadius: "16px",
              padding: "25px",
              textAlign: "center",
              boxShadow: "0 20px 50px rgba(15,23,42,.25)",
              boxSizing: "border-box",
            }}
          >
            <h4
              style={{
                color: "#dc3545",
                margin: 0,
                fontSize: "19px",
                fontWeight: 700,
              }}
            >
              Delete Item
            </h4>

            <p
              style={{
                marginTop: "15px",
                marginBottom: 0,
                color: "#667085",
                fontSize: "14px",
                lineHeight: 1.6,
              }}
            >
              Are you sure you want to delete
              <br />
              <strong style={{ color: "#202938" }}>
                {itemToDelete.name}
              </strong>{" "}
              ?
            </p>

            <div
              style={{
                display: "flex",
                gap: "10px",
                marginTop: "22px",
              }}
            >
              <button
                onClick={() => {
                  setShowDeleteModal(false);
                  setItemToDelete(null);
                }}
                style={{
                  flex: 1,
                  minHeight: "42px",
                  padding: "10px",
                  border: "1px solid #dfe3e8",
                  borderRadius: "9px",
                  background: "#fff",
                  color: "#475467",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Cancel
              </button>

              <button
                onClick={confirmDeleteItem}
                style={{
                  flex: 1,
                  minHeight: "42px",
                  padding: "10px",
                  border: "none",
                  borderRadius: "9px",
                  background: "#dc3545",
                  color: "#fff",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ================= ADD UNIT MODAL ================= */}

      {showAddUnitModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15,23,42,.58)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "15px",
            zIndex: 1000000,
            backdropFilter: "blur(3px)",
          }}
        >
          <div
            style={{
              width: "400px",
              maxWidth: "100%",
              background: "#fff",
              borderRadius: "16px",
              padding: "25px",
              boxShadow: "0 20px 50px rgba(15,23,42,.25)",
              boxSizing: "border-box",
            }}
          >
            <h3
              style={{
                margin: "0 0 20px",
                textAlign: "center",
                color: "#202938",
                fontSize: "19px",
                fontWeight: 700,
              }}
            >
              Add Unit
            </h3>

            <input
              type="text"
              value={newUnitName}
              onChange={(e) =>
                setNewUnitName(e.target.value)
              }
              placeholder="Enter Unit Name"
              autoFocus
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();

                  if (selectedFormIndex !== null) {
                    handleAddUnit(selectedFormIndex);
                  }
                }
              }}
              style={{
                width: "100%",
                height: "44px",
                padding: "0 13px",
                border: "1px solid #dfe5ed",
                borderRadius: "9px",
                outline: "none",
                fontSize: "14px",
                boxSizing: "border-box",
              }}
            />

            <div
              style={{
                display: "flex",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <button
                type="button"
                onClick={() => {
                  setShowAddUnitModal(false);
                  setNewUnitName("");
                  setSelectedFormIndex(null);
                }}
                style={{
                  flex: 1,
                  minHeight: "42px",
                  padding: "10px",
                  border: "1px solid #dfe3e8",
                  borderRadius: "9px",
                  background: "#fff",
                  color: "#475467",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Cancel
              </button>

              <button
                type="button"
                disabled={addingUnit}
                onClick={() => {
                  if (selectedFormIndex !== null) {
                    handleAddUnit(selectedFormIndex);
                  }
                }}
                style={{
                  flex: 1,
                  minHeight: "42px",
                  padding: "10px",
                  border: "none",
                  borderRadius: "9px",
                  background: "#F96E5B",
                  color: "#fff",
                  cursor: addingUnit
                    ? "not-allowed"
                    : "pointer",
                  fontWeight: 600,
                  opacity: addingUnit ? 0.7 : 1,
                }}
              >
                {addingUnit ? "Adding..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ================= TABLE ================= */}

      <div className="items-table-wrapper">
        <div className="table-header">
          <span>Item Name</span>
          <span>Category</span>
          <span>Purchase Price</span>
          <span>Sale Price</span>
          <span>Stock</span>
          <span>GST</span>
          <span>Activity</span>
        </div>

        {filteredInventory.length > 0 ? (
          filteredInventory.map((item) => (
            <div
              key={item.id}
              className="table-row"
            >
              <span title={item.name}>
                {item.name}
              </span>

              <span title={item.category}>
                {item.category}
              </span>

              <span>
                ₹{item.pur_price}
              </span>

              <span>
                ₹{item.sale_price}
              </span>

              <span>
                {item.stock}
              </span>

              <span>
                {item.taxRate}
              </span>

              <span className="action-btns">
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() =>
                    handleEdit(item)
                  }
                  title="Edit"
                >
                  <FaEdit />
                </button>

                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() =>
                    handleDelete(item)
                  }
                  title="Delete"
                >
                  <FaTrash />
                </button>
              </span>
            </div>
          ))
        ) : (
          <div className="empty-state">
            <h3>No Items to Show</h3>
          </div>
        )}
      </div>

      {/* ================= ADD CATEGORY MODAL ================= */}

      {showAddCategoryModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15,23,42,.58)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "15px",
            zIndex: 999999,
            backdropFilter: "blur(3px)",
          }}
        >
          <div
            style={{
              width: "400px",
              maxWidth: "100%",
              background: "#fff",
              borderRadius: "16px",
              padding: "25px",
              boxShadow: "0 20px 50px rgba(15,23,42,.25)",
              boxSizing: "border-box",
            }}
          >
            <h3
              style={{
                margin: "0 0 20px",
                textAlign: "center",
                color: "#202938",
                fontSize: "19px",
                fontWeight: 700,
              }}
            >
              Add Category
            </h3>

            <input
              type="text"
              value={newCategoryName}
              onChange={(e) =>
                setNewCategoryName(e.target.value)
              }
              placeholder="Enter Category Name"
              autoFocus
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();

                  handleAddCategory(
                    selectedFormIndex
                  );
                }
              }}
              style={{
                width: "100%",
                height: "44px",
                padding: "0 13px",
                border: "1px solid #dfe5ed",
                borderRadius: "9px",
                outline: "none",
                fontSize: "14px",
                boxSizing: "border-box",
              }}
            />

            <div
              style={{
                display: "flex",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <button
                type="button"
                onClick={() => {
                  setShowAddCategoryModal(false);
                  setNewCategoryName("");
                  setSelectedFormIndex(null);
                }}
                style={{
                  flex: 1,
                  minHeight: "42px",
                  padding: "10px",
                  border: "1px solid #dfe3e8",
                  borderRadius: "9px",
                  background: "#fff",
                  color: "#475467",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Cancel
              </button>

              <button
                type="button"
                disabled={addingCategory}
                onClick={() =>
                  handleAddCategory(
                    selectedFormIndex
                  )
                }
                style={{
                  flex: 1,
                  minHeight: "42px",
                  padding: "10px",
                  border: "none",
                  borderRadius: "9px",
                  background: "#F96E5B",
                  color: "#fff",
                  cursor: addingCategory
                    ? "not-allowed"
                    : "pointer",
                  fontWeight: 600,
                  opacity: addingCategory ? 0.7 : 1,
                }}
              >
                {addingCategory
                  ? "Adding..."
                  : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
            {/* ================= PRODUCT FORM ================= */}

      {showItemForm && (
        <div className="party-modal-overlay">
          <div className="item-modal">

            <div className="item-modal-header">
              <h2>
                {editId ? "Edit Product" : "Add Product"}
              </h2>

              <button
                className="back-btn"
                onClick={() => {
                  setShowItemForm(false);
                  setEditId(null);
                  setForms([
                    ...forms,
                    { ...emptyProduct },
                  ]);
                }}
              >
                ← Back
              </button>
            </div>

            <div className="product-layout">
              <div className="form-sections">

                {forms.map((form, index) => (
                  <div
                    key={index}
                    className="product-card"
                  >

                    <div className="row">

                      {/* ================= LEFT FORM ================= */}

                      <div className="col-md-9">

                        <h2 className="mb-3">
                          Product {index + 1}
                        </h2>

                        {/* ITEM DETAILS */}

                        <div className="form-card">
                          <h3>Item Details</h3>

                          <div className="item-grid">

                            <input
                              name="name"
                              value={form.name}
                              onChange={(e) =>
                                handleChange(index, e)
                              }
                              placeholder="Item Name*"
                            />

                            <input
                              name="barcode"
                              value={form.barcode}
                              onChange={(e) =>
                                handleChange(index, e)
                              }
                              placeholder="Item Code"
                            />

                            <input
                              name="hsn_code"
                              value={form.hsn_code}
                              onChange={(e) =>
                                handleChange(index, e)
                              }
                              placeholder="HSN Code"
                            />

                            <select
                              name="category"
                              value={form.category}
                              onChange={(e) => {
                                if (
                                  e.target.value ===
                                  "__ADD_CATEGORY__"
                                ) {
                                  setSelectedFormIndex(index);
                                  setNewCategoryName("");
                                  setShowAddCategoryModal(true);
                                  return;
                                }

                                handleChange(index, e);
                              }}
                            >
                              <option value="">
                                Select Category
                              </option>

                              {categories.map((cat) => (
                                <option
                                  key={cat.id}
                                  value={cat.cat_name}
                                >
                                  {cat.cat_name}
                                </option>
                              ))}

                              <option value="__ADD_CATEGORY__">
                                + Add Category
                              </option>
                            </select>

                            <select
                              name="unit"
                              value={form.unit}
                              onChange={(e) => {
                                if (
                                  e.target.value ===
                                  "__ADD_UNIT__"
                                ) {
                                  setSelectedFormIndex(index);
                                  setNewUnitName("");
                                  setShowAddUnitModal(true);
                                  return;
                                }

                                handleChange(index, e);
                              }}
                            >
                              <option value="">
                                Select Unit
                              </option>

                              {units.map((unit) => (
                                <option
                                  key={unit.id}
                                  value={unit.cat_name}
                                >
                                  {unit.cat_name}
                                </option>
                              ))}

                              <option value="__ADD_UNIT__">
                                + Add Unit
                              </option>
                            </select>

                            <input
                              type="date"
                              name="mfgDate"
                              value={form.mfgDate}
                              onChange={(e) =>
                                handleChange(index, e)
                              }
                            />

                          </div>
                        </div>

                        {/* ================= PRICE DETAILS ================= */}

                        <div className="form-card">
                          <h3>Price Details</h3>

                          <div className="item-grid">

                            <input
                              name="mrp"
                              value={form.mrp}
                              onChange={(e) =>
                                handleChange(index, e)
                              }
                              placeholder="MRP Price*"
                            />

                            <div className="position-relative w-100">

                              <input
                                type="text"
                                name="pur_price"
                                value={form.pur_price}
                                onChange={(e) =>
                                  handleChange(index, e)
                                }
                                placeholder="Purchase Price*"
                                className="form-control"
                              />

                              <button
                                type="button"
                                className="btn btn-sm position-absolute top-50 end-0 translate-middle-y me-2"
                                onClick={() => {
                                  const value =
                                    !purPriceWithTax;

                                  setPurPriceWithTax(value);

                                  const updatedForms = [
                                    ...forms,
                                  ];

                                  updatedForms[index]
                                    .pur_price_withTax =
                                    value
                                      ? "With Tax"
                                      : "Without Tax";

                                  setForms(updatedForms);
                                }}
                              >
                                {purPriceWithTax
                                  ? "With Tax"
                                  : "Without Tax"}
                              </button>

                            </div>

                            <div className="position-relative w-100">

                              <input
                                type="text"
                                name="sale_price"
                                value={form.sale_price}
                                onChange={(e) =>
                                  handleChange(index, e)
                                }
                                placeholder="Sale Price*"
                                className="form-control"
                              />

                              <button
                                type="button"
                                className="btn btn-sm position-absolute top-50 end-0 translate-middle-y me-2"
                                onClick={() => {
                                  const value =
                                    !salePriceWithTax;

                                  setSalePriceWithTax(value);

                                  const updatedForms = [
                                    ...forms,
                                  ];

                                  updatedForms[index]
                                    .sale_price_withTax =
                                    value
                                      ? "With Tax"
                                      : "Without Tax";

                                  setForms(updatedForms);
                                }}
                              >
                                {salePriceWithTax
                                  ? "With Tax"
                                  : "Without Tax"}
                              </button>

                            </div>

                            <div className="position-relative w-100">

                              <input
                                type="text"
                                name="discount"
                                value={form.discount}
                                onChange={(e) =>
                                  handleChange(index, e)
                                }
                                placeholder="Discount"
                                className="form-control"
                              />

                              <button
                                type="button"
                                className="btn btn-sm position-absolute top-50 end-0 translate-middle-y me-2"
                                onClick={() => {
                                  const value =
                                    !discountInPercent;

                                  setDiscountInPercent(value);

                                  const updatedForms = [
                                    ...forms,
                                  ];

                                  updatedForms[index]
                                    .dis_in_percent =
                                    value
                                      ? "Percent"
                                      : "Amount";

                                  setForms(updatedForms);
                                }}
                              >
                                {discountInPercent
                                  ? "% Percentage"
                                  : "₹ Amount"}
                              </button>

                            </div>

                            <input
                              type="date"
                              name="expDate"
                              value={form.expDate || ""}
                              onChange={(e) =>
                                handleChange(index, e)
                              }
                            />

                            <select
                              name="taxRate"
                              value={form.taxRate}
                              onChange={(e) =>
                                handleChange(index, e)
                              }
                            >
                              <option value="">
                                Tax Rate
                              </option>

                              <option value="None">
                                None
                              </option>

                              <option value="GST 0%">
                                GST 0%
                              </option>

                              <option value="IGST 0%">
                                IGST 0%
                              </option>

                              <option value="GST 0.25%">
                                GST 0.25%
                              </option>

                              <option value="IGST 0.25%">
                                IGST 0.25%
                              </option>

                              <option value="GST 3%">
                                GST 3%
                              </option>

                              <option value="IGST 3%">
                                IGST 3%
                              </option>

                              <option value="GST 5%">
                                GST 5%
                              </option>

                              <option value="IGST 5%">
                                IGST 5%
                              </option>

                              <option value="GST 12%">
                                GST 12%
                              </option>

                              <option value="IGST 12%">
                                IGST 12%
                              </option>

                              <option value="GST 18%">
                                GST 18%
                              </option>

                              <option value="IGST 18%">
                                IGST 18%
                              </option>

                              <option value="GST 28%">
                                GST 28%
                              </option>

                              <option value="IGST 28%">
                                IGST 28%
                              </option>
                            </select>

                          </div>
                        </div>

                        {/* ================= STOCK DETAILS ================= */}

                        <div className="form-card">
                          <h3>Stock Details</h3>

                          <div className="item-grid">

                            <input
                              name="stock"
                              value={form.stock}
                              onChange={(e) =>
                                handleChange(index, e)
                              }
                              placeholder="Opening Quantity*"
                            />

                            <input
                              name="stock_at_price"
                              value={form.stock_at_price}
                              onChange={(e) =>
                                handleChange(index, e)
                              }
                              placeholder="At Price*"
                            />

                            <input
                              name="min_to_maintain"
                              value={form.min_to_maintain}
                              onChange={(e) =>
                                handleChange(index, e)
                              }
                              placeholder="Min Stock*"
                            />

                            <input
                              name="stock_place"
                              value={form.stock_place}
                              onChange={(e) =>
                                handleChange(index, e)
                              }
                              placeholder="Location*"
                            />

                            <input
                              type="date"
                              name="date"
                              value={form.date || ""}
                              onChange={(e) =>
                                handleChange(index, e)
                              }
                            />

                          </div>
                        </div>

                      </div>

                      {/* ================= IMAGE ================= */}

                      <div className="col-md-3">

                        <div className="image-upload-section">

                          <h3>Product Image</h3>

                          <div className="image-upload-box">

                            {form.imagePreview ? (
                              <img
                                src={form.imagePreview}
                                alt="preview"
                                className="preview-image"
                              />
                            ) : (
                              <div className="upload-placeholder">
                                <FaCamera size={50} />
                                <p>Upload Image</p>
                              </div>
                            )}

                            <input
                              type="file"
                              accept="image/*"
                              className="image-input"
                              onChange={(e) =>
                                handleImageChange(index, e)
                              }
                            />

                          </div>

                        </div>

                      </div>

                    </div>
                  </div>
                ))}

              </div>
            </div>

            {/* ================= FOOTER ================= */}

            <div className="item-footer">

              {!editId && (
                <>
                  <button
                    className="more-btn"
                    onClick={handleAddMore}
                  >
                    + Add More
                  </button>

                  <button
                    className="less-btn"
                    onClick={handleAddLess}
                  >
                    - Add Less
                  </button>
                </>
              )}

              <button
                className="submit-btn"
                onClick={handleSubmit}
              >
                {editId ? "Update" : "Submit"}
              </button>

            </div>

          </div>
        </div>
      )}

    </div>
  );
};

export default Items;




















